import { parseQueryFromLocation } from '../../routing/operators/parseQueryFromLocation';
export const getVerifyFbmInstall = location => parseQueryFromLocation(location).messengerInstall;